module.exports = __webpack_public_path__ + "static/media/tm6_3.511b5e30.svg";